export var folderDetailPage = {
    breadcrumbLocation: 'Locations',
    folderItem: 'list',
    folderItems: 'lists',
    folderLocation: 'location',
    folderLocations: 'locations',
    noLists: 'This folder contains no lists!',
};
